import { Badge } from '@shared/ui';

type VersioningBannerProps = {
  version: string;
};

export const VersioningBanner = ({ version }: VersioningBannerProps) => {
  return <Badge variant={'outline'}>{`Beta ${version}`}</Badge>;
};
